import {
  SET_TODOS,
  SET_CURRENT_TODO_PARTICIPANT,
  SET_CURRENT_TODO_UPDATE,
  IS_SUCCESS_SAVE_TODO_PARTICIPANT,
  IS_SUCCESS_DELETE_TODO_PARTICIPANT,
  IS_ERROR_DELETE_TODO_PARTICIPANT,
  IS_ERROR_SAVE_TODO_PARTICIPANT,
  SET_TODOS_STATUS,
  RESET_TODOS,
  SET_LATEST_FOCUS_AREA,
} from "../actions/actionTypes";

const DEFAULT_CURRENT_TODO_VALUES = {
  participantProfileId: "",
  todoId: 0,
  title: "",
  description: "",
  completed: false,
  categoryId: -1,
  categoryName: "",
  originId: 1,
  origin: "Participant",
  dueDate: null,
  focusAreaId: 0,
  score: 0,
  reminderTypeId: 0,
  content: [],
};

const initialState = {
  assessmentTodos: [],
  participantAdminTodos: [],
  currentListStatus: {
    participantProfileId: "",
    completed: 0,
    incompleted: 0,
  },
  currentTodo: { ...DEFAULT_CURRENT_TODO_VALUES },
  successSaveTodoParticpant: false,
  errorsSaveTodoParticpant: false,
  errorsMessageSaveTodoParticpant: "",
  successDeleteTodoParticpant: {
    status: false,
    message: "",
  },
  errorsDeleteTodoParticpant: {
    status: false,
    message: "",
  },
  errorsMessageDeleteTodoParticpant: "",
  latestFocusAreas: [],
};
export const todosReducer = (state = initialState, actions) => {
  if (actions.type === SET_TODOS) {
    const assessmentTodos = [];
    const participantAdminTodos = [];
    const todos = actions.payload;
    for (let idx = 0; idx < todos.length; idx += 1) {
      const todo = todos[idx];
      if (todo.originId === 3) {
        assessmentTodos.push(todo);
      } else {
        participantAdminTodos.push(todo);
      }
    }
    return {
      ...state,
      assessmentTodos,
      participantAdminTodos,
    };
  }
  if (actions.type === SET_CURRENT_TODO_PARTICIPANT) {
    return {
      ...state,
      currentTodo: { ...DEFAULT_CURRENT_TODO_VALUES, ...actions.payload },
    };
  }
  if (actions.type === SET_CURRENT_TODO_UPDATE) {
    return {
      ...state,
      currentTodo: { ...state.currentTodo, ...actions.payload },
    };
  }
  if (actions.type === IS_SUCCESS_SAVE_TODO_PARTICIPANT) {
    return {
      ...state,
      successSaveTodoParticpant: actions.payload,
    };
  }
  if (actions.type === IS_SUCCESS_DELETE_TODO_PARTICIPANT) {
    return {
      ...state,
      successDeleteTodoParticpant: actions.payload,
    };
  }
  if (actions.type === IS_ERROR_DELETE_TODO_PARTICIPANT) {
    return {
      ...state,
      errorsDeleteTodoParticpant: actions.payload,
    };
  }
  if (actions.type === IS_ERROR_SAVE_TODO_PARTICIPANT) {
    const { status, message } = actions.payload;
    return {
      ...state,
      errorsSaveTodoParticpant: status,
      errorsMessageSaveTodoParticpant: message,
    };
  }
  if (actions.type === SET_TODOS_STATUS) {
    return {
      ...state,
      currentListStatus: actions.payload,
    };
  }
  if (actions.type === RESET_TODOS) {
    return {
      ...state,
      assessmentTodos: [],
      participantAdminTodos: [],
    };
  }
  if (actions.type === SET_LATEST_FOCUS_AREA) {
    return {
      ...state,
      latestFocusAreas: actions.payload,
    };
  }
  return state;
};
